import settingsRoutes from './modules/settings'
import templatesRoutes from './modules/templates'

const routes = [
  {
    path: '/',
    meta: { requiresAuth: true },
    component: () => import('layouts/MainLayout.vue'),
    children: [
      {
        name: 'Root',
        path: '',
        redirect: { name: 'DashboardPage' }
      },
      {
        name: 'DashboardPage',
        path: '/dashboard',
        component: () => import('pages/DashboardPage.vue')
      },
      ...settingsRoutes,
      ...templatesRoutes
    ]
  }
]

export default routes
